import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_MODULOS = 'ALL_MODULOS';
export const LOADING_ALL_MODULOS = 'LOADING_ALL_MODULOS';
export const ACTIVO_MODULOS = 'ACTIVO_MODULOS';
export const PARAMS_MODULOS = 'PARAMS_MODULOS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const modulosReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_MODULOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_MODULOS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_MODULOS:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_MODULOS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
